import { render, staticRenderFns } from "./ReviewDatasetForms.vue?vue&type=template&id=c320e874"
import script from "./ReviewDatasetForms.vue?vue&type=script&lang=js"
export * from "./ReviewDatasetForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports